__turbopack_context__.v({
  "ant-upload-disabled": "npc-model-with-preview-uploader-module__Akm3-G__ant-upload-disabled",
  "ant-upload-drag-icon": "npc-model-with-preview-uploader-module__Akm3-G__ant-upload-drag-icon",
  "ant-upload-hint": "npc-model-with-preview-uploader-module__Akm3-G__ant-upload-hint",
  "ant-upload-text": "npc-model-with-preview-uploader-module__Akm3-G__ant-upload-text",
  "darkTheme": "npc-model-with-preview-uploader-module__Akm3-G__darkTheme",
  "dragger": "npc-model-with-preview-uploader-module__Akm3-G__dragger",
  "fileInfo": "npc-model-with-preview-uploader-module__Akm3-G__fileInfo",
  "fileName": "npc-model-with-preview-uploader-module__Akm3-G__fileName",
  "npcModelWithPreviewUploader": "npc-model-with-preview-uploader-module__Akm3-G__npcModelWithPreviewUploader",
  "sectionTitle": "npc-model-with-preview-uploader-module__Akm3-G__sectionTitle",
  "uploadButton": "npc-model-with-preview-uploader-module__Akm3-G__uploadButton",
  "uploadButtonSection": "npc-model-with-preview-uploader-module__Akm3-G__uploadButtonSection",
  "uploadContent": "npc-model-with-preview-uploader-module__Akm3-G__uploadContent",
  "uploaderSection": "npc-model-with-preview-uploader-module__Akm3-G__uploaderSection",
});
